var map = {
	"./webspecial_food_sushi_cn.mp4": 3655,
	"./webspecial_food_sushi_de.mp4": 3565,
	"./webspecial_food_sushi_en.mp4": 9973,
	"./webspecial_food_sushi_ja.mp4": 9079,
	"./webspecial_food_sushi_tr.mp4": 8654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2235;